import Repository from "./Repository";

const sessions = "/sessions";

export default {
  heartbeat: (token) => Repository.post(`${sessions}/heartbeat/`, { token }),
};
